import styled from "styled-components"

const TransferInfo = styled.div`
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  white-space: nowrap;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  hr {
    position: absolute;
    width: 100%;
    top: 50%;
    height: 1px;
    background-color: ${props => props.theme.color.text};
    border: none;
  }
`

export default TransferInfo
